<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.getAll();
    this.$store.dispatch("lookups/getDoctors");

  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.pharmacy.totalItems / this.filters.pageSize
      );
    },
    pharmacy() {
      return this.$store.state.pharmacy.pharmacy;
    },
    user() {
      return this.$store.state.security.user;
    },

  },
  data() {
    return {
      permissions: this.$patientsManagementPermissions.doctorPrescriptionsPermissions,
      view: 0,
      dialog: false,
      dialogType: null,
      dialogMessage: "",
      filters: {
        page: 1,
        pageSize: 10,
        fullName: null,
        phoneNo: null,
        orderNo: null,
      },
      headers: [
        { text: 'رقم الطلب ', value: 'orderNo' },
        { text: "اسم الحالة", value: 'fullName' },
        { text: "حالة الطلب ", value: "status", sortable: false },
        { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],

      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("pharmacy/getAll", this.filters);

    },

    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
      // Implement edit logic
    },
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف البيانات";
          break;
        case "approval":
          this.dialogMessage = "هل انت متأكد من رغبتك اعتماد البيانات";
          break;

      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },
    handleClear() {
      this.filters.transferDate = null;
    },
    confirmDialog() {
      this.$store.dispatch(`pharmacy/${this.dialogType}`,{ id: this.itemId, doctorId: this.filters.doctorId });
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
    back() {
      this.view = 0;
      this.getAll()
    }
  },
};
</script>

<style scoped></style>